import React from "react";

import "./App.css";

import { PantyBlinker } from "./PantyBlinker";
import { Generator } from "./Generator";

const colors: { r: number, g: number, b: number}[] = [
    { r: 255, g: 154, b: 162 },
    { r:  226, g: 240, b: 203 },
    { r:  181, g: 234, b: 215 },
    // { r:  255, g: 218, b: 193 },
    // { r:  199, g: 206, b: 234 },
    // { r:  255, g: 183, b: 178 }
];

function App() {
    const panties = colors.map((color, index) => (
        <div key={index} className="PantiesBlinkerContainer">
            <PantyBlinker r={color.r} g={color.g} b={color.b}/>
        </div>
    ));


    return (
        <div className="MainContainer">
            <img className="Image" src="logo512.png" alt="logo"/>
            <div className="PantiesContainer">
                {panties}
            </div>

            <div className="Intro">NEW FOR 2023! <b>PANTYBOT 6000</b>&trade; WITH QUILT SUPPORT!</div>
            <div className="InputContainer">Visit&nbsp;<a href="https://quilt.farm">Quilt Farm</a>&nbsp;to make your own quilts!</div>
            <Generator />

            <div className="EMailContainer">
                <p>Interested in panties? <a href="mailto:panties@natespantyemporium.com?subject=I WANT PANTIES">E-mail us!</a></p>
            </div>
        </div>
    );
}

export default App;


// panties@natespantyemporium.com